import thumbnail_neura from '../Neura/thumbnail.png';

import image0 from '../Neura/0.png';
import image1 from '../Neura/1.png';
import image2 from '../Neura/2.png';
import image3 from '../Neura/3.png';
import image4 from '../Neura/4.png';
import image5 from '../Neura/5.png';
import image6 from '../Neura/6.png';
import image7 from '../Neura/7.png';

export const NeuraApp = {
  id:5,
  type: 'mobile',
  thumbnails: [thumbnail_neura],
  screens: [image0, image1, image2, image3, image4, image5, image6, image7],
  title: 'Neura – Your Daily Mental Health Companion for Mindfulness, Support, and Well-being',
  intro:
    "Neura is a thoughtfully designed mental health app that supports users in building better habits, reducing stress, and enhancing emotional resilience. With daily exercises, personalized follow-ups, and wellness tracking, Neura helps individuals take proactive steps toward mental well-being — right from their mobile devices. Let’s explore how Neura makes self-care simple and effective.",
  features: [
    {
      title: "Daily Guided Mental Health Exercises",
      description:
        "Start each day with personalized exercises like breathing, journaling, mindfulness, and cognitive tasks designed to reduce stress, improve focus, and enhance emotional balance."
    },
    {
      title: "Mood & Progress Tracking",
      description:
        "Track how you feel over time with mood check-ins and progress charts. Understand patterns in your emotional state and identify what works best for your mental well-being."
    },
    {
      title: "Smart Daily Follow-Ups",
      description:
        "Neura checks in with you daily to offer supportive messages, self-reflection prompts, or quick exercises based on your recent activity and emotional trends."
    },
    {
      title: "Personalized Wellness Plans",
      description:
        "Get a custom mental wellness plan tailored to your goals, challenges, and schedule. Whether you're managing anxiety, burnout, or simply looking to build a healthy routine — Neura adapts to your needs."
    },
    {
      title: "Audio Sessions and Meditations",
      description:
        "Access a library of guided meditations, calming audio tracks, and focus exercises to help manage stress, improve sleep, and regain calm anytime you need."
    },
    {
      title: "Private Journal and Reflection Space",
      description:
        "Write down your thoughts, feelings, and reflections in a secure in-app journal. Use it as a safe space to process emotions and document your mental health journey."
    },
    {
      title: "Reminders & Gentle Notifications",
      description:
        "Stay consistent with smart, non-intrusive reminders that help you keep up with your mental health routine without adding pressure."
    }
  ],
  conclusion:
    "Neura empowers you to prioritize your mental well-being with consistency and compassion. With its gentle daily approach, science-backed exercises, and personal progress insights, Neura makes mental health care accessible and supportive for everyone. Take your first step toward better balance — download Neura today."
};
